import styles from './style.module.scss';
import { Button, Row } from 'antd';
import { src } from '../../../utils/common';
import { Fade } from 'react-awesome-reveal';
import router from 'next/router';
import useUserAgentInfo from '@/hooks/useUserAgentInfo';
import { RightOutline } from 'antd-mobile-icons';
import { WebPNativeImage } from '../../WebPImage';
import classnames from 'classnames';
import Link from 'next/link';
import { gotoArticleByProduct } from '@/utils/document/article-and-product';
import { productCodes } from '@/utils/document/product-code-map';
import { IBanner } from '@/utils/const/products/interface';

type BannerProps = {
  bannerData: Partial<IBanner>;
  onTry?: () => void;
  mode?: 'product' | 'solution' | 'value';
  textMode?: boolean;
};

const DetailBanner = ({
  bannerData,
  onTry = () => router.push('/form/consult/try'),
  mode = 'product',
  textMode = false,
}: BannerProps) => {
  const backgroundMap = {
    product: '#eafcff',
    solution: '#eff3f8',
    value: '#C5D6E7',
  };
  const { isMobile } = useUserAgentInfo();
  const judgeIsArray = (val) => {
    return val instanceof Array;
  };
  const routeChange = (link) => {
    link
      ? link.startsWith('http')
        ? window.open(link, '_blank')
        : router.push(link) // 以http开头的心开页面，其余的使用router
      : onTry();
  };

  const OperateButtons = ({ buttonText, buttonLink }) => {
    const isArray = judgeIsArray(buttonText);
    let tempText = isArray ? buttonText : [buttonText];
    let tempLink = isArray ? buttonLink : [buttonLink];
    // 移动端只展示第一个
    tempText = isMobile ? [tempText[0]] : tempText;
    tempLink = isMobile ? [tempLink[0]] : tempLink;
    return (
      <Row>
        {tempText?.map((item, i) => {
          return (
            <Button
              key={item}
              type="primary"
              className={styles['button']}
              onClick={() => routeChange(tempLink[i])}
            >
              {item}
            </Button>
          );
        })}
      </Row>
    );
  };

  return (
    <div
      className={classnames({
        [styles['banner']]: true,
        [styles['concise']]: !bannerData.buttonText,
      })}
      style={{ background: backgroundMap[mode] }}
    >
      <div
        className={classnames({
          [styles['cover']]: true,
          [styles['cover-solution']]: mode === 'solution',
          [styles['cover-value']]: mode === 'value',
        })}
      >
        <WebPNativeImage
          src={src(
            isMobile ? bannerData.backgroundImgMobile : bannerData.backgroundImg
          )}
          alt="banner"
          className={styles['background']}
          crossOrigin="anonymous"
        />
      </div>
      <div className={styles['container']}>
        <Fade>
          <div className={styles['content']}>
            <div className={styles['banner-title']}>{bannerData.title}</div>
            <div
              className={`${
                textMode ? styles['align-description'] : styles['description']
              }`}
            >
              {bannerData.description}
            </div>
            {bannerData.buttonText && (
              <div className={styles['btn']}>
                <OperateButtons
                  buttonText={bannerData.buttonText}
                  buttonLink={bannerData.buttonLink}
                />
                {isMobile && bannerData.mobileExtraButton && (
                  <Button
                    type={'link'}
                    className={`${styles['button']} ${styles['doc-button']}`}
                    onClick={() => {
                      const { mobileExtraButton } = bannerData;
                      // 当 mobileExtraButton.link 是 productCodes 中的 productCode 时，远程根据code获取文档地址
                      if (productCodes.includes(mobileExtraButton.link)) {
                        gotoArticleByProduct(
                          {
                            productCode: mobileExtraButton.link,
                          },
                          false
                        );
                      } else {
                        router.push(bannerData.mobileExtraButton.link);
                      }
                    }}
                  >
                    {bannerData.mobileExtraButton.name}
                  </Button>
                )}
              </div>
            )}
            {isMobile &&
              judgeIsArray(bannerData.buttonText) &&
              bannerData.buttonText.length > 1 &&
              (bannerData.buttonText as string[]).map((item, i) => {
                if (i > 0) {
                  return (
                    <Button
                      type="link"
                      className={styles.moreButtonText}
                      key={i}
                      onClick={() => routeChange(bannerData.buttonLink[i])}
                    >
                      {`${item}`} <RightOutline />
                    </Button>
                  );
                }
              })}
            {bannerData.links && (
              <div className={styles['links']}>
                {bannerData.links.map((item, index) => (
                  <div
                    key={index}
                    className={`${styles['link']} ${
                      item.link ? '' : styles['disable']
                    }`}
                  >
                    {productCodes.includes(item.link) ? (
                      <span
                        style={{ marginRight: '4px', letterSpacing: '1px' }}
                        onClick={() =>
                          gotoArticleByProduct({ productCode: item.link })
                        }
                      >
                        {item.name}
                      </span>
                    ) : (
                      <Link
                        href={item.link}
                        passHref
                        style={{ marginRight: '4px', letterSpacing: '1px' }}
                        target="_blank"
                      >
                        {item.name}
                      </Link>
                    )}
                    <WebPNativeImage
                      src={src('/img/rightArrow.svg')}
                      alt="rightArrow"
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default DetailBanner;
